import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=d16d6306&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=d16d6306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16d6306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d16d6306')) {
      api.createRecord('d16d6306', component.options)
    } else {
      api.reload('d16d6306', component.options)
    }
    module.hot.accept("./Navbar.vue?vue&type=template&id=d16d6306&scoped=true&", function () {
      api.rerender('d16d6306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Navbar.vue"
export default component.exports